import { TAPlanStatus } from './TAPlan.types';

export function getTAPlanIcon(status: TAPlanStatus) {
    switch (status) {
        case TAPlanStatus.Coming:
            return 'ta-plan-coming';
        case TAPlanStatus.Current:
            return 'ta-plan-current';
        case TAPlanStatus.RecentlyCompleted:
            return 'ta-plan-completed';
        default:
            return null;
    }
}
